import { Component, OnInit } from '@angular/core';
import { SharedService }          from '../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private activatedRoute : ActivatedRoute ,private sharedService: SharedService, private localStorageService: LocalStorageService, private router: Router) {
    this.sharedService.setHeaderTitle("default_page");
    let that = this.sharedService;
    setTimeout(function(){ 
        that.setHeaderTitle("page_not_found");
    }, 10);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/page-not-found/page-not-found/page-not-found.component.ts